
import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import { CartVO } from "@/views/biz/order/vo/cart.vo";
import debounce from "lodash-es/debounce";
import Criteo from "@/criteo";
import { CriteoVO } from "@/vo/criteo.vo";
import { MobionVO } from "@/vo/mobion.vo";
import AdLogs from "@/ad-logs";

@Component
export default class Cart extends Vue {
  cart: Array<CartVO> = [];
  checkedCart: Array<CartVO> = [];
  checkAll = false; // 전체선택
  goPaymentKey = 0; // 중복 클릭 방지
  inited = false;

  // computed

  // 주문액 합계
  get salePriceSum(): number {
    let result = 0;
    for (const i in this.checkedCart) {
      result += this.checkedCart[i].salePrice * this.checkedCart[i].count;
    }
    return result;
  }

  @Watch("checkAll") toggleCheckAll() {
    this.checkedCart = [];
    if (this.checkAll) {
      for (let i = 0; i < this.cart.length; i++) {
        this.checkedCart.push(this.cart[i]);
      }
    }
  }

  // method

  // 최대구매수량
  maxOrderQuantity(item: CartVO): number {
    switch (item.productType) {
      case "01": // 일반
        return item.maxOrderCnt; // 1회최대구매수량
      case "02":
        return Math.min(item.stockCnt, item.maxOrderCnt); // 재고수
    }
    return 0;
  }

  // 수량 변경
  changeCount(item: CartVO, quantity: number): void {
    const count = item.count + quantity;
    // 수량이 1보다 작거나 1인구매수량, 재고보다 많으면 안됨
    if (count < 1) {
      return;
    }
    if (count > this.maxOrderQuantity(item)) {
      this.$toast(this.$t("t0110").toString());
      return;
    }
    item.count = count;

    this.updateCartCount(item);
  }

  // 수량 변경 서버 반영
  updateCartCount = debounce((params) => {
    axios.put("/order/cart", params);
  }, 500);

  // 장바구니 삭제
  deleteCart(): void {
    if (!this.checkedCart.length) {
      // 선택된 상품이 없습니다.
      alert(this.$t("order.a0001"));
      return;
    }
    // 삭제하시겠습니까?
    if (!confirm(this.$t("order.c0001").toString())) {
      return;
    }

    axios.post("/order/cart/delete", this.checkedCart).then(() => {
      this.initCart();
      this.$store.dispatch("updateCartCount");
      this.checkedCart = [];
    });
  }

  mobionCartParams(data: any): object{
  const product = [] as MobionVO[];
      let totalQuantity = 0; 
      let totalPriceAll = 0;
      data.forEach((item) => {
        const obj = {} as MobionVO;
        obj.productCode = item.productCd;
        obj.productName = item.productNm;
        obj.qty = item.count;
        obj.price = item.salePrice;
        product.push(obj);
        totalQuantity+=item.count;
        totalPriceAll +=item.salePrice;
      });
        return {
        product,
        totalQty : totalQuantity,
        totalPrice : totalPriceAll,
      }
  }

  // 장바구니 목록
  initCart() {
    axios.get("/order/cart").then((r) => {
      this.cart = r.data as Array<CartVO>;
      this.inited = true;
      this.checkAll = true;
      AdLogs.sendMobionCart(this.mobionCartParams(r.data))
      //크리테오 장바구니 목록
      // console.log("크리테오 장바구니 목록 : ");
      // console.log(r.data);
      // Criteo.putQuery({
      //   path : '',
      //   oneTag : Criteo.criteoTags.CART_TAG,
      //   data : r.data
      // } as CriteoVO);

      })
    }

  // 결제
  goPayment(): void {
    if (!this.checkedCart.length) {
      this.$toast(this.$t("order.a0001")); // 선택된 상품이 없습니다.
      this.goPaymentKey++;
      return;
    }

    // cart 테이블하고 order 테이블하고 count 명명이 다름 ㅠㅠ
    this.checkedCart.forEach((cart) => {
      cart.orderCount = cart.count;
    });
    axios
      .post("/order/cart/order", this.checkedCart)
      .then((r) => {
        const orderCd = r.data as string;
        this.$router.push({ name: "OrderPayment", params: { orderCd: orderCd } });
      })
      .catch(() => {
        this.goPaymentKey++;
        //TODO 실패 사유
      });
  }

  activated() {
    this.goPaymentKey++; // 장바구니 갔다 뒤로하기 하면 다시 결제 안돼서
  }

  // init
  created() {
    this.$store.dispatch("updateCartCount");
    this.initCart();
  }
}
